/** Every zone the browser knows, UTC, and the person's own: by name. */
export function zonesWith(own: readonly string[]): string[] {
  return [...new Set([...Intl.supportedValuesOf("timeZone"), "UTC", ...own])].sort((a, b) =>
    a.localeCompare(b, "en-US"),
  );
}
